import { render, staticRenderFns } from "./TwoStepBody.vue?vue&type=template&id=3c5c649d&scoped=true"
import script from "./TwoStepBody.vue?vue&type=script&lang=js"
export * from "./TwoStepBody.vue?vue&type=script&lang=js"
import style0 from "./TwoStepBody.vue?vue&type=style&index=0&id=3c5c649d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5c649d",
  null
  
)

export default component.exports